<template>
  <header class="navbar">
    <div class="logo"><a href="/" class="logo-link">{{ productName }}</a></div>

    <!-- 汉堡菜单按钮 (移动端显示) -->
    <button class="hamburger" @click="toggleMobileMenu" aria-label="Toggle menu">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <nav :class="{ 'mobile-active': mobileMenuOpen }">
      <ul class="main-menu">

        <!-- 用户管理 (带下拉菜单) -->
        <li class="menu-item dropdown"
            @mouseenter="isDesktop && openMenu('user')"
            @mouseleave="isDesktop && closeMenu('user')"
            @click="!isDesktop && toggleMenu('user')">
          <span class="menu-title">
            {{ $t('nav.userManagement') }}
            <i class="arrow" :class="{ 'down': isMenuOpen('user') }"></i>
          </span>
          <transition name="fade">
            <ul class="submenu" v-show="isMenuOpen('user')">
              <li><router-link to="/user-mgmt" @click="closeMobileMenu">{{ $t('nav.userConfig') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <!-- 文件管理 (带下拉菜单) -->
        <li class="menu-item dropdown" v-if="isModuleEnabled('filemgmt')"
            @mouseenter="isDesktop && openMenu('file')"
            @mouseleave="isDesktop && closeMenu('file')"
            @click="!isDesktop && toggleMenu('file')">
          <span class="menu-title">
            {{ $t('nav.fileManagement') }}
            <i class="arrow" :class="{ 'down': isMenuOpen('file') }"></i>
          </span>
          <transition name="fade">
            <ul class="submenu" v-show="isMenuOpen('file')">
              <li v-if="loadCompo?.includes('admin')"><router-link to="/file-setting" @click="closeMobileMenu">{{ $t('nav.fileConfig') }}</router-link></li>
              <li><router-link to="/file-list" @click="closeMobileMenu">{{ $t('nav.fileList') }}</router-link></li>
              <li><router-link to="/collect-list" @click="closeMobileMenu">{{ $t('nav.favorites') }}</router-link></li>
              <li><router-link to="/shareLink-list" @click="closeMobileMenu">{{ $t('nav.shareFolder') }}</router-link></li>
              <li v-if="loadCompo?.includes('admin')"><router-link to="/network-file-services" @click="closeMobileMenu">{{ $t('nav.networkFileService') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('fileSync')" >
          <router-link to="/file-sync-mgmt"  @click="closeMobileMenu">{{ $t('nav.fileSync') }}</router-link>
        </li>

        <li class="menu-item dropdown" v-if="isServerManagementEnabled && loadCompo?.includes('admin')"
            @mouseenter="isDesktop && openMenu('server')"
            @mouseleave="isDesktop && closeMenu('server')"
            @click="!isDesktop && toggleMenu('server')">
          <span class="menu-title">
            {{ $t('nav.serverManagement') }}
            <i class="arrow" :class="{ 'down': isMenuOpen('server') }"></i>
          </span>
          <transition name="fade">
            <ul class="submenu" v-show="isMenuOpen('server')">
              <li><router-link to="/transfer-server" @click="closeMobileMenu">{{ $t('nav.transferServer') }}</router-link></li>
              <li><router-link to="/distribution-server" @click="closeMobileMenu">{{ $t('nav.distributionServer') }}</router-link></li>
              <li><router-link to="/official-client" @click="closeMobileMenu">{{ $t('nav.officialClient') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('mapping')">
          <router-link to="/server-mapping" @click="closeMobileMenu">{{ $t('nav.serverMapping') }}</router-link>
        </li>

        <li class="menu-item dropdown"  v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('p2p')"
            @mouseenter="isDesktop && openMenu('p2p')"
            @mouseleave="isDesktop && closeMenu('p2p')"
            @click="!isDesktop && toggleMenu('p2p')">
          <span class="menu-title">
            {{ $t('nav.p2pManagement') }}
            <i class="arrow" :class="{ 'down': isMenuOpen('p2p') }"></i>
          </span>
          <transition name="fade">
            <ul class="submenu" v-show="isMenuOpen('p2p')">
              <li><router-link to="/p2p-setting" @click="closeMobileMenu">{{ $t('nav.p2pSetting') }}</router-link></li>
              <li><router-link to="/p2p-client" @click="closeMobileMenu">{{ $t('nav.p2pClient') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <li class="menu-item dropdown" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('proxy')"
            @mouseenter="isDesktop && openMenu('proxy')"
            @mouseleave="isDesktop && closeMenu('proxy')"
            @click="!isDesktop && toggleMenu('proxy')">
          <span class="menu-title">
            {{ $t('nav.proxyManagement') }}
            <i class="arrow" :class="{ 'down': isMenuOpen('proxy') }"></i>
          </span>
          <transition name="fade">
            <ul class="submenu" v-show="isMenuOpen('proxy')">
              <li><router-link to="/proxy-mgmt" @click="closeMobileMenu">{{ $t('nav.forwardProxy') }}</router-link></li>
              <li><router-link to="/reverse-proxy" @click="closeMobileMenu">{{ $t('nav.reverseProxy') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <li class="menu-item dropdown" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('dns')"
            @mouseenter="isDesktop && openMenu('ddns')"
            @mouseleave="isDesktop && closeMenu('ddns')"
            @click="!isDesktop && toggleMenu('ddns')">
          <span class="menu-title">
            {{ $t('nav.ddnsManagement') }}
            <i class="arrow" :class="{ 'down': isMenuOpen('ddns') }"></i>
          </span>
          <transition name="fade">
            <ul class="submenu" v-show="isMenuOpen('ddns')">
              <li @click="closeMobileMenu"><router-link to="/ddns-setting">{{ $t('nav.ddnsSetting') }}</router-link></li>
              <li @click="closeMobileMenu"><router-link to="/aliyun-ddns">{{ $t('nav.aliyunDdns') }}</router-link></li>
              <li @click="closeMobileMenu"><router-link to="/tencentcloud-ddns">{{ $t('nav.tencentcloudDdns') }}</router-link></li>
              <li @click="closeMobileMenu"><router-link to="/pubyun-ddns">{{ $t('nav.pubyunDdns') }}</router-link></li>
              <li @click="closeMobileMenu"><router-link to="/nameyun-ddns">{{ $t('nav.namecomDdns') }}</router-link></li>
              <li @click="closeMobileMenu"><router-link to="/cloudflare-ddns">{{ $t('nav.cloudflareDdns') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <!-- 其他菜单项 -->
        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('acme')">
          <router-link to="/acme-mgmt" @click="closeMobileMenu">{{ $t('nav.acmeManagement') }}</router-link>
        </li>

        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && !loadCompo?.includes('darwin') && isModuleEnabled('mountManagement')">
          <router-link to="/mount-mgmt" @click="closeMobileMenu">{{ $t('nav.mountSettings') }}</router-link>
        </li>

        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('deviceCenter')">
          <router-link to="/device-center" @click="closeMobileMenu">{{ $t('nav.deviceCenter') }}</router-link>
        </li>

        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin')">
          <router-link to="/module-mgmt" @click="closeMobileMenu">{{ $t('nav.moduleManagement') }}</router-link>
        </li>

        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin')">
          <router-link to="/sys-setting" @click="closeMobileMenu">{{ $t('nav.systemSettings') }}</router-link>
        </li>

        <li class="menu-item">
          <router-link to="/sys-about" @click="closeMobileMenu">{{ $t('nav.about') }}</router-link>
        </li>

<!--
        <li class="menu-item" v-if="loadCompo?.includes('oldweb')">
          <a href="#" @click.prevent="goToLegacyHome" class="old-page-link">{{ $t('nav.legacyEntry') }}</a>
        </li>
-->
      </ul>

      <div class="logout" @click="handleLogout">
        <span v-if="isLoggedIn">{{ $t('nav.logout', { username }) }}</span>
        <span v-else>{{ $t('nav.loggedOut') }}</span>
      </div>

      <div class="lang-switcher">
        <el-dropdown @command="handleLangCommand" trigger="click">
          <span class="lang-trigger">
            <el-icon><Globe /></el-icon>
            {{ langLabel }}
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="zh-cn" :disabled="locale === 'zh-cn'">简体中文</el-dropdown-item>
              <el-dropdown-item command="en" :disabled="locale === 'en'">English</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </nav>

  </header>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useLangStore } from '@/stores/lang'
import { Globe } from '@element-plus/icons-vue'
import eventBus from '@/utils/eventBus';
import { API_BASE_URL } from "@/config";
import { HOME_BASE_URL } from "@/config";

export default {
  name: 'AppSidebar',
  setup() {
    const { locale } = useI18n()
    const langStore = useLangStore()

    const langLabel = computed(() => locale.value === 'zh-cn' ? '中文' : 'EN')

    const handleLangCommand = (cmd) => {
      locale.value = cmd
      langStore.setLocale(cmd)
    }

    const activeMenu = ref('')
    const openMenus = ref([])
    const isLoggedIn = ref(false)
    const username = ref('')
    const router = useRouter()
    const loadCompo = ref('')
    const productName = ref('tfcenter')
    const mobileMenuOpen = ref(false)
    const isDesktop = ref(window.innerWidth > 768)
    const moduleStatus = ref({})  // 模块启用状态

    // 获取模块状态
    const fetchModuleStatus = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/modules`, {
          credentials: 'include'
        })
        const result = await response.json()
        if (result.code === 0 && result.data) {
          const status = {}
          result.data.forEach(mod => {
            status[mod.name] = mod.enabled
          })
          moduleStatus.value = status
        }
      } catch (e) {
        console.error('获取模块状态失败', e)
      }
    }

    // 检查模块是否启用
    const isModuleEnabled = (name) => {
      return moduleStatus.value[name] === true
    }

    // 服务器管理是否启用
    const isServerManagementEnabled = computed(() => {
      return moduleStatus.value['serverManagement'] === true
    })

    // 检查窗口大小并更新isDesktop
    const checkScreenSize = () => {
      isDesktop.value = window.innerWidth > 768
      if (isDesktop.value) {
        mobileMenuOpen.value = false
      }
    }

    // 检查登录状态
    const checkLoginStatus = () => {
      const userInfo = localStorage.getItem('userInfo')
      if (userInfo) {
        try {
          const user = JSON.parse(userInfo)
          isLoggedIn.value = true
          username.value = user.username || '未知用户'
          loadCompo.value = user.loadCompo || ''
          productName.value = user.productName || 'tfcenter'
        } catch (e) {
          console.error('解析用户信息失败', e)
          isLoggedIn.value = false
        }
      } else {
        isLoggedIn.value = false
      }
    }

    // 登出处理
    const handleLogout = () => {
      if (isLoggedIn.value) {
        fetch(`${API_BASE_URL}/logout`, {
          method: 'POST',
          credentials: 'include',
        })

        localStorage.removeItem('userInfo')
        isLoggedIn.value = false
        username.value = ''
        closeMobileMenu()
        router.push('/user-login?auto=n')
      } else {
        closeMobileMenu()
        router.push('/user-login?auto=n')
      }
    }

    const isMenuOpen = (menu) => openMenus.value.includes(menu)
    const openMenu = (menu) => {
      if (!openMenus.value.includes(menu)) {
        openMenus.value.push(menu)
      }
    }
    const closeMenu = (menu) => {
      openMenus.value = openMenus.value.filter(m => m !== menu)
    }
    const toggleMenu = (menu) => {
      if (isMenuOpen(menu)) {
        closeMenu(menu)
      } else {
        openMenu(menu)
      }
    }
    
    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value
    }
    
    const closeMobileMenu = () => {
      if (!isDesktop.value) {
        mobileMenuOpen.value = false
      }
    }

    // 组件挂载时检查登录状态和窗口大小
    onMounted(() => {
      checkLoginStatus()
      checkScreenSize()
      fetchModuleStatus()
      window.addEventListener('resize', checkScreenSize)

      // 监听登录事件
      eventBus.on('login', (user) => {
        if (user.username == undefined || user.username == '') {
          isLoggedIn.value = false
        } else {
          isLoggedIn.value = loadCompo
        }
        username.value = user.username;
        loadCompo.value = user.loadCompo
        fetchModuleStatus()
      });

      // 监听模块状态变化事件
      eventBus.on('module-changed', () => {
        fetchModuleStatus()
      });
    })
    
    // 组件卸载前移除事件监听
    onBeforeUnmount(() => {
      window.removeEventListener('resize', checkScreenSize)
    })

    return {
      locale,
      setLocale: langStore.setLocale,
      langLabel,
      handleLangCommand,
      Globe,
      activeMenu,
      isMenuOpen,
      openMenu,
      closeMenu,
      toggleMenu,
      isLoggedIn,
      username,
      productName,
      loadCompo,
      handleLogout,
      mobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu,
      isDesktop,
      isModuleEnabled,
      isServerManagementEnabled
    }
  },
  methods: {
    goToLegacyHome() {
      window.location.href = HOME_BASE_URL + '/home';
    }
  }
}
</script>

<style scoped>
/* 修改导航栏的布局 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

/* 只在移动端添加 space-between */
@media (max-width: 768px) {
  .navbar {
    justify-content: space-between;
  }
}

.logo {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  margin: 5px 10px 10px 10px;
}

.logo-link {
  text-decoration: none;   /* 移除下划线 */
  color: #FFFFFF;         /* 使用Element UI的主色调蓝色 */
  font-weight: 600;       /* 中等加粗 */
  font-size: 1.2rem;      /* 稍大的字号 */
  letter-spacing: 1px;    /* 字间距微调 */
  transition: color 0.3s; /* 颜色过渡动画 */
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif; /* 中文字体优化 */
}

.logo-link:hover {
  color: #337ecc;         /* 悬停时加深蓝色 */
  text-decoration: none;  /* 确保悬停时也无下划线 */
}

.old-page-link {
  text-decoration: none;
  color: #FFFFFF;
  font-size: 1rem;
  letter-spacing: 1px;
  transition: color 0.3s;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

.old-page-link:hover {
  color: #337ecc;
  text-decoration: none;
}

/* 汉堡菜单样式 */
.hamburger {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  margin-right:15px;
  padding: 10px;
  z-index: 1001;
}

.hamburger span {
  display: block;
  width: 25px;
  height: 3px;
  background: white;
  margin: 5px 0;
  transition: all 0.3s ease;
}

/* 导航菜单样式 */
nav {
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.main-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  height: 100%;
}

.menu-item {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}

.menu-item a, .menu-title {
  color: #ecf0f1;
  text-decoration: none;
  padding: 0 15px;
  height: 100%;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
  cursor: pointer;
}

.menu-item a:hover, .menu-title:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.menu-item a.router-link-exact-active {
  background-color: #3498db;
}

.dropdown:hover .submenu {
  display: block;
}

.submenu {
  position: absolute;
  top: 60px;
  left: 0;
  background: #2c3e50;
  min-width: 180px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 0 0 4px 4px;
  overflow: hidden;
  z-index: 1000;
}

.submenu a {
  padding: 10px 15px;
  display: block;
}

.submenu a:hover {
  background-color: #3498db;
}

.arrow {
  display: inline-block;
  margin-left: 5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #ecf0f1;
  transition: transform 0.3s;
}

.arrow.down {
  transform: rotate(180deg);
}

.logout {
  margin-left: 30px;
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 15px;
  color: #ecf0f1;
  padding: 0 15px;
}

.logout:hover {
  color: #3498db;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 移动端样式 */
@media (max-width: 768px) {
  .hamburger {
    display: block;
  }
  
  nav {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    background: #2c3e50;
    flex-direction: column;
    align-items: flex-start;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }
  
  nav.mobile-active {
    max-height: 100vh;
    overflow-y: auto;
  }
  
  .main-menu {
    flex-direction: column;
    width: 100%;
    height: auto;
  }
  
  .menu-item {
    width: 100%;
    height: auto;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .menu-item a, .menu-title {
    width: 100%;
    padding: 15px 20px;
  }
  
  .submenu {
    position: static;
    width: 100%;
    box-shadow: none;
    display: none;
  }
  
  .submenu a {
    padding-left: 30px;
  }
  
  .logout {
    width: 100%;
    margin: 0;
    padding: 15px 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  /* 汉堡菜单动画 */
  .mobile-active + .hamburger span:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
  }
  
  .mobile-active + .hamburger span:nth-child(2) {
    opacity: 0;
  }
  
  .mobile-active + .hamburger span:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
  }
}

.lang-switcher {
  margin-left: 16px;
  padding-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}
</style>